export default "__VITE_ASSET__BwMnkSnq__"